import React from 'react';
import { Modal } from '@carvana/showroom-modal';
import {
  ModalContentWrapper,
  Title,
  MainHeader,
  SubHeader,
  Paragraph,
  HyperLink,
} from './ElectronicPaymentTerms.styles';

const ElectronicPaymentTerms = ({
  openModal,
  toggleTermsModal,
  isOneTimeTerms = false,
}: any) => {
  return (
    <Modal
      headerText="TERMS AND CONSENTS"
      mode="light"
      isOpen={openModal}
      closeModal={toggleTermsModal}
    >
      <ModalContentWrapper>
        {isOneTimeTerms && (
          <>
            <Title>ONE-TIME BANK PAYMENT</Title>
            <MainHeader>TERMS AND CONDITIONS</MainHeader>
            <Paragraph>
              I am giving Bridgecrest the authority to debit my account and
              apply the funds in payment of my contract. I authorize Bridgecrest
              to initiate electronic entries if necessary to correct any errors
              you may make. I will help Bridgecrest verify deposit account
              information if Bridgecrest asks me to. The information I have
              provided to Bridgecrest is correct and complete as far as I know
              and I am authorized to have funds deducted from this account to
              make payments under my contract with Bridgecrest. I have elected
              to do one time ACH for my convenience and Bridgecrest did not
              require me to do so. I know there must be enough funds for the
              payment to be made. If there are not and the ACH is returned,
              Bridgecrest may try again as long as the applicable ACH rules
              allow you to do so. I understand if the ACH is returned, I may
              incur fees for the return and any late payments under my contract.
              I understand I cannot cancel or edit my ACH payment on the same
              day I scheduled the payment to be withdrawn from my bank account.
            </Paragraph>
          </>
        )}
        <MainHeader>
          Consent To Use Electronic Signatures and Communications
        </MainHeader>

        <Paragraph>
          Please read this carefully and print a copy for your reference.
        </Paragraph>
        <SubHeader>1. DEFINITIONS</SubHeader>
        <Paragraph>
          “We,” “us,” “our” and “Bridgecrest” Bridgecrest Acceptance Corporation
          and Bridgecrest Credit Company, LLC, individually and collectively,
          and their respective successors and assigns. “You” and “your” means
          the person giving this consent. “Records” means all documents related
          to the sale and financing of a used motor vehicle from Bridgecrest,
          such as your credit application, your retail installment contract,
          consumer disclosures, billing statements, online bill payments and
          payment authorizations, transaction histories, privacy policies, and
          all other communication or information related to the product or
          service you obtain from us, including any records we are required by
          law to provide to you in writing.
        </Paragraph>
        <SubHeader>2. SCOPE OF CONSENT</SubHeader>
        <Paragraph>
          By giving your consent, you agree to conduct your transaction with
          Bridgecrest using electronic signatures. You agree that such
          electronic signatures will consist of clicking on buttons and/or
          checking boxes where indicated. You also consent to the use of
          electronic Records, including Records sent to you electronically,
          instead of receiving them on paper or by regular mail. We may provide
          Records to you electronically by posting them online or by email,
          which may include the Records as attachments or as embedded links.
          Your consent will be effective unless you withdraw it in the manner
          provided below.
        </Paragraph>
        <SubHeader>3. HOW TO UPDATE YOUR CONTACT INFORMATION</SubHeader>
        <Paragraph>
          You agree to provide us with your accurate email address and personal
          contact information and to promptly notify us of any changes. You can
          update your information (including your email address) on our website
          or by contacting us at{' '}
          <HyperLink href="tel:8009678526" type="external">800-967-8526</HyperLink>. If email is
          undeliverable to your email address for three consecutive months, your
          consent will be considered withdrawn and we will send you future
          Records in writing.
        </Paragraph>
        <SubHeader>4. OBTAINING PAPER COPIES</SubHeader>
        <Paragraph>
          You may obtain a paper copy of a Record by printing it from your
          computer or by contacting us at{' '}
          <HyperLink href="tel:8009678526" type="external">800-967-8526</HyperLink>. We may
          charge you a reasonable service charge for providing you with a paper
          copy of any Record. The request for a paper copy of a Record will not
          by itself constitute a withdrawal of your consent to receive Records
          electronically. We reserve the right, but are not required, to send a
          paper copy of any Record you authorize us to provide electronically.
        </Paragraph>
        <SubHeader>5. WITHDRAWING CONSENT</SubHeader>
        <Paragraph>
          You may at any time withdraw your consent to receive Records
          electronically, and instead elect at any time to use the U.S. Postal
          Service to obtain Records, by un-enrolling your AutoPay agreement
          through your online Bridgecrest.com account or by contacting us at{' '}
          <HyperLink href="tel:8009678526" type="external">800-967-8526</HyperLink>. We will not
          impose any fee if you withdraw your consent to receive Records
          electronically. If you withdraw your consent to receive Records
          electronically, such withdrawal will not apply to Records that were
          furnished to you electronically before the date on which the
          withdrawal of your consent takes effect.
        </Paragraph>
        <SubHeader>6. HARDWARE AND SOFTWARE REQUIREMENTS</SubHeader>
        <Paragraph>
          To use electronic signatures and Records you need to have a computer
          that supports the use of Microsoft Internet Explorer 7.0 or higher,
          Mozilla Firefox 3.5 or higher, Chrome, Safari 5.0 or higher, or an
          equivalent. You will need an active email account. You also need
          hardware as necessary to support this software, including, without
          limitation, a personal computer using a Windows 98, NT, 2000, ME XP,
          Vista or 7 operating system that supports 128-bit encryption,
          sufficient storage space to save copies of your Records, a modem with
          internet access, and a printer if you wish to print paper copies. You
          will need a program that can view, save and print PDF files (such as
          Adobe Reader 6.0 or higher). You can download a copy of Adobe Reader
          here: http://get.adobe.com/reader. Save and print a copy of this
          document to make sure that you have the necessary hardware and
          software. If we ever change the hardware or software requirements for
          using electronic Records and signatures, the revised requirements will
          be posted upon your next session log in.
        </Paragraph>
        <MainHeader>COMMUNICATIONS TO YOU</MainHeader>
        <Paragraph>
          1. The communications between you and us usually use electronic means,
          whether you access, visit or use the Service, send us messages, or
          whether we post notices on the Service or communicate with you via
          messaging. For contractual purposes, you (a) consent to receive
          communications from us in electronic form; and (b) agree that all
          notices, documents, disclosures, and other communications that we
          provide to you electronically satisfy any legal requirement that such
          communications would satisfy if they were in writing. Your consent to
          receive communications and do business electronically, and your
          agreement to do so applies to all of your interactions and
          transactions with us.
        </Paragraph>
        <Paragraph>
          2. You understand and agree that joining the Service may include
          receiving certain communications from us, such as transactional or
          relationship messages, and/or messages about your account/profile, and
          that these communications are considered part of your account/profile
          and you may not be able to opt out of receiving them without ceasing
          to be a registered user of the Service.
        </Paragraph>
        <Paragraph>
          3. If you wish to opt out of text messages and no longer have the text
          message with instructions for opting out, you can reply STOP at any
          time to any text message communication from Bridgecrest.
        </Paragraph>
      </ModalContentWrapper>
    </Modal>
  );
};
export default ElectronicPaymentTerms;
